import { defineComponent as _defineComponent } from 'vue'
import { Row } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

interface ILegendData {
  color: string;
  leftTitle: string;
  leftSubtitle: string;
  rightTitle: string;
  rightSubtitle: string;
}

interface Props {
  data: ILegendData[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChartLegend',
  props: {
    data: null
  },
  setup(__props: any) {



return { __sfc: true,Row, Money }
}

})